export const validation = {
  required: "必須項目です",
  email: "有効なメールアドレスを入力してください",
  minLength: (args: { min: string | number }) =>
    `${args.min}文字以上で入力してください`,
  maxLength: (args: { max: string | number }) =>
    `${args.max}文字以内で入力してください`,
  passwordMismatch: "パスワードが一致しません",
} as const;
